module.exports = __webpack_public_path__ + "files/0d8f188e79b7bf378f58405f31bcef8c.png";